import {Box, Typography} from "@mui/material";
import React from "react";
import FileIcon from "../../../../assets/icons/fileIcon";
import CrossIcon from "../../../../assets/icons/crossIcon";
import {setAttachments} from "@store/chatSlice.tsx";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "@store/store.tsx";


const FilesSelectedCard = () => {
    const attachments = useSelector((state: any) => state.chat.attachments);
    const dispatch = useDispatch<AppDispatch>();
    const handleRemoveFile = (indexToRemove: number) => {
        dispatch(setAttachments(attachments.filter((_: any, index: number) => index !== indexToRemove)));
    };
    return (
        <Box
            className="flex flex-row gap-4 absolute bottom-0 w-full bg-white p-4 shadow-2xl"
            sx={{
                overflowX: "auto",
                "::-webkit-scrollbar": {
                    height: "5px",
                },

                "::-webkit-scrollbar-track": {
                    backgroundColor: "#f1f1f1",
                },

                "::-webkit-scrollbar-thumb": {
                    backgroundColor: "#C0C0C0",
                },
                "::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "gray",
                },
            }}
        >
            {
                attachments.map((file: any, index: number) => (
                    <Box
                        key={file?.name}
                        className="flex min-w-[60%] sm:min-w-[56%] md:min-w-[30%] lg:min-w-[22%] xl:min-w-[15%] mb-1"
                        sx={{
                            backgroundColor: "rgba(255, 247, 215, 1)",
                            boxShadow: 3,
                            borderRadius: "4px",
                            position: "relative",
                        }}
                    >
                        <Box className="flex items-center p-3 ">
                            <Box>
                                <FileIcon/>
                            </Box>
                            <Box className="pl-2">
                                <Typography variant="subtitle2">
                                    {" "}
                                    {file?.name?.length > 17
                                        ? file?.name.slice(0, 16) + "..."
                                        : file?.name}
                                </Typography>
                                <Typography className="!text-[10px]">{`${(
                                    file?.size /
                                    1024 /
                                    1024
                                ).toFixed(2)} MB`}</Typography>
                            </Box>
                        </Box>
                        <Typography
                            className="absolute right-0"
                            onClick={() => handleRemoveFile(index)}
                        >
                            <CrossIcon/>
                        </Typography>
                    </Box>
                ))}
        </Box>
    );
};

export default FilesSelectedCard;
